import { ControlConfig } from '../controlConfig';
import AddControlFormula from './AddControlCalculatedValue';
import ControlCalculatedValueEngine from './ControlCalculatedValueEngine';
import ControlCalculatedValueEntry from './ControlCalculatedValueEntry';
import ControlCalculatedValuePlaceholder from './ControlCalculatedValuePlaceholder';
import getLatestSchema from './schema';
import getDefaultValue from './getDefaultValue';
import getYupSchemaForCalculatedValueEngine from './getYupSchemaForCalculatedValueEngine';
import getYupSchemaForCalculatedValueEntry from './getYupSchemaForCalculatedValueEntry';
import translator from './translator';

export default {
  getDefaultValue,
  getLatestSchema,
  Engine: ControlCalculatedValueEngine,
  Entry: ControlCalculatedValueEntry,
  Add: AddControlFormula,
  yupSchemaEngine: getYupSchemaForCalculatedValueEngine,
  yupSchemaEntry: getYupSchemaForCalculatedValueEntry,
  translator,
  Placeholder: ControlCalculatedValuePlaceholder,
  previewCardHeight: '120px'
} as ControlConfig;
